import { Link, Navigate, useParams } from "react-router-dom";
import { HiArrowLeft, HiArrowRight, HiOutlineCheckCircle } from "../../components/common/LightIcons";
import Reveal from "../../components/common/Reveal";
import CTA from "../../components/common/CTA";
import Seo from "../../components/common/Seo";
import { blogPosts, services } from "../../data/siteData";

export default function BlogDetail() {
  const { slug } = useParams();
  const post = blogPosts.find(p => p.slug === slug);
  if (!post) return <Navigate to="/blogs" replace/>;
  const service = services.find(s => s.slug === post.serviceSlug);
  return <>
    <Seo title={post.title} description={post.excerpt} />
    <article>
      <section className="blog-detail-hero"><div className="hero-grid"/><div className="shell blog-detail-inner">
        <Link to="/blogs" className="back-link"><HiArrowLeft/> All insights</Link>
        <div className="blog-detail-meta"><span>{post.category}</span><i/> <span>{post.date}</span><i/> <span>{post.readTime}</span></div>
        <h1>{post.title}</h1><p>{post.excerpt}</p>
        <div className={`blog-detail-art ${post.heroClass}`}><div className="blog-orbit big"><i/><i/><i/></div><span>INSIGHT / NAVASTHA</span></div>
      </div></section>
      <section className="article-section"><div className="shell article-layout"><aside><span>In this article</span>{post.sections.map((s,i)=><a href={`#section-${i}`} key={s.heading}>0{i+1} {s.heading}</a>)}</aside><div className="article-body"><Reveal><p className="article-lead">{post.intro}</p></Reveal>{post.sections.map((section,i)=><Reveal key={section.heading}><section id={`section-${i}`} className="article-chapter"><span>0{i+1}</span><h2>{section.heading}</h2>{section.paragraphs.map(p=><p key={p}>{p}</p>)}{section.bullets && <ul>{section.bullets.map(b=><li key={b}><HiOutlineCheckCircle/>{b}</li>)}</ul>}</section></Reveal>)}{service && <Reveal><div className="article-service-card"><span>Related service</span><h3>{service.title}</h3><p>{service.short}</p><Link to={`/services/${service.slug}`}>Explore the service <HiArrowRight/></Link></div></Reveal>}</div></div></section>
    </article>
    <CTA/>
  </>;
}
